export default {
  booking: {
    loading: false,
    error: false,
    data: false
  },
  changes: {},
  savingChanges: false
};
